module.exports = __webpack_public_path__ + "media/images/admin/magazines/separator_white-e1c866ebc109e6993cda80ee0e011fd3.png";